import { Box, Paper } from '@mui/material'
import { type ReactNode } from 'react'

const CentredPanel = ({ children }: { children: ReactNode }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh"
    bgcolor="background.default"
  >
    <Paper sx={{ p: 4, width: '100%', maxWidth: 420 }}>{children}</Paper>
  </Box>
)

export default CentredPanel
